export default __webpack_public_path__ + "static/media/Print-06.48a6fb1b.svg";